/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */

'use client';

import React, { useCallback, useEffect, useRef, useState } from 'react';

import useReCaptchaContext from '@/hooks/useReCaptchaContext';

import styles from './ReCaptcha.module.scss';

const ReCaptcha = ({
  action,
  callback,
  isResetNeeded,
}: {
  action: string;
  callback: (token: string) => void;
  isResetNeeded?: boolean;
}) => {
  const [widgetId, setWidgetId] = useState(undefined);
  const reCaptchaContainerRef = useRef(null);
  const context = useReCaptchaContext();

  const errorCallback = useCallback(() => {
    (window as any).grecaptcha.enterprise.reset(widgetId);
    callback('');
  }, [callback, widgetId]);

  useEffect(() => {
    if (window) {
      if (!context.isLoaded) return;
      window?.grecaptcha.enterprise.ready(() => {
        if (widgetId !== undefined) return;

        setWidgetId(
          window.grecaptcha?.enterprise.render(reCaptchaContainerRef.current, {
            action,
            callback,
            'expired-callback': errorCallback,
            'error-callback': errorCallback,
            sitekey: context.sitekey,
          }),
        );
      });
    }
  }, [action, context, callback, setWidgetId, widgetId, errorCallback]);

  useEffect(() => {
    if (isResetNeeded) {
      (window as any).grecaptcha.enterprise.reset(widgetId);
    }
  }, [isResetNeeded, widgetId]);

  return (
    <div className={styles.recaptchaContainer}>
      <label htmlFor="g-recaptcha-response" className={styles.labelHidden}>
        reCAPTCHA response
      </label>
      <div ref={reCaptchaContainerRef} />
    </div>
  );
};

export default ReCaptcha;
